var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 470.23 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#0078d4;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:#36baed;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1023.38,
    y1: -19.08,
    x2: -1037.99,
    y2: 24.08,
    gradientTransform: "translate(1631.81 35) scale(1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1018.82,
    y1: 1.04,
    x2: -1022.2,
    y2: 2.18,
    gradientTransform: "translate(1631.81 35) scale(1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1020.57,
    y1: -20.38,
    x2: -1004.53,
    y2: 22.35,
    gradientTransform: "translate(1631.81 35) scale(1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.77,0h22L23.93,67.61A3.51,3.51,0,0,1,20.61,70H3.5A3.5,3.5,0,0,1,0,66.5a3.55,3.55,0,0,1,.18-1.12l21.26-63A3.52,3.52,0,0,1,24.77,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.71,45.35H21.85A1.61,1.61,0,0,0,20.24,47a1.63,1.63,0,0,0,.51,1.19l22.4,20.9a3.51,3.51,0,0,0,2.4,1H65.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.77,0a3.46,3.46,0,0,0-3.33,2.43L.21,65.32a3.49,3.49,0,0,0,2.11,4.47A3.43,3.43,0,0,0,3.51,70H21.06a3.75,3.75,0,0,0,2.88-2.45l4.23-12.47,15.12,14.1a3.64,3.64,0,0,0,2.25.82H65.21L56.58,45.35H31.44L46.83,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.84,2.38A3.5,3.5,0,0,0,49.53,0H25a3.5,3.5,0,0,1,3.31,2.38l21.27,63A3.49,3.49,0,0,1,46.29,70h24.5a3.5,3.5,0,0,0,3.5-3.5,3.55,3.55,0,0,0-.18-1.12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.23,56.24h-6.62v-26q0-3.19.4-7.82h-.12a27,27,0,0,1-1.09,3.78l-12,30.06h-4.6l-12-29.83a28.58,28.58,0,0,1-1.07-4H90c.15,1.6.23,4.23.23,7.87v26H84.05V16h9.39L104,42.81a38.06,38.06,0,0,1,1.57,4.6h.14c.69-2.11,1.26-3.68,1.69-4.71L118.17,16h9.06Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.58,23.26a3.92,3.92,0,0,1-2.74-1,3.43,3.43,0,0,1-1.13-2.64,3.52,3.52,0,0,1,1.13-2.66,3.87,3.87,0,0,1,2.74-1.07,4,4,0,0,1,2.8,1.07,3.47,3.47,0,0,1,1.15,2.66,3.4,3.4,0,0,1-1.15,2.59A3.89,3.89,0,0,1,138.58,23.26Zm3.22,33h-6.5V27.53h6.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.75,54.92a16,16,0,0,1-8.16,2,13.84,13.84,0,0,1-10.32-4,14.16,14.16,0,0,1-3.93-10.36q0-7.1,4.22-11.4t11.29-4.31a16.42,16.42,0,0,1,6.93,1.38v6.05a10.52,10.52,0,0,0-6.4-2.24,8.87,8.87,0,0,0-6.75,2.79A10.21,10.21,0,0,0,154,42.14a9.75,9.75,0,0,0,2.48,7,8.83,8.83,0,0,0,6.66,2.58,10.44,10.44,0,0,0,6.62-2.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.75,33.72a5.41,5.41,0,0,0-3.39-.92,5.8,5.8,0,0,0-4.82,2.61,11.65,11.65,0,0,0-1.94,7.09V56.24h-6.51V27.53h6.51v5.91h.11a10.07,10.07,0,0,1,2.93-4.72,6.63,6.63,0,0,1,4.42-1.7,5.54,5.54,0,0,1,2.69.53Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.47,56.91q-6.65,0-10.61-4t-4-10.67q0-7.23,4.14-11.3t11.14-4.07q6.74,0,10.49,4t3.76,11q0,6.87-4,11T207.47,56.91ZM207.78,32a7.43,7.43,0,0,0-6,2.67,11.11,11.11,0,0,0-2.21,7.34,10.49,10.49,0,0,0,2.24,7.11,7.55,7.55,0,0,0,6,2.6,7.15,7.15,0,0,0,5.9-2.56q2.07-2.55,2.07-7.26t-2.07-7.32A7.11,7.11,0,0,0,207.78,32Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.14,55.34v-6a13,13,0,0,0,8.05,2.77c3.92,0,5.89-1.16,5.89-3.48a2.69,2.69,0,0,0-.51-1.66,4.76,4.76,0,0,0-1.36-1.22,10.27,10.27,0,0,0-2-1l-2.59-1a27.23,27.23,0,0,1-3.19-1.49,9.3,9.3,0,0,1-2.35-1.78,6.6,6.6,0,0,1-1.42-2.26,8.24,8.24,0,0,1-.47-2.94,6.77,6.77,0,0,1,1-3.66A8.55,8.55,0,0,1,229.78,29a12.64,12.64,0,0,1,3.76-1.63,17.4,17.4,0,0,1,4.35-.55A19.83,19.83,0,0,1,245,28.06v5.69a12,12,0,0,0-6.95-2.07,9,9,0,0,0-2.23.25,5.76,5.76,0,0,0-1.7.7A3.41,3.41,0,0,0,233,33.71a2.51,2.51,0,0,0-.4,1.39,2.89,2.89,0,0,0,.4,1.57,3.49,3.49,0,0,0,1.16,1.13,9.67,9.67,0,0,0,1.85.9c.72.27,1.55.57,2.48.88a36.33,36.33,0,0,1,3.33,1.55,11.14,11.14,0,0,1,2.51,1.78,6.88,6.88,0,0,1,1.59,2.3,7.7,7.7,0,0,1,.56,3.1,7,7,0,0,1-1,3.81,8.43,8.43,0,0,1-2.69,2.69,12.65,12.65,0,0,1-3.88,1.59,20.49,20.49,0,0,1-4.64.51A19.51,19.51,0,0,1,226.14,55.34Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.32,56.91q-6.65,0-10.61-4t-4-10.67q0-7.23,4.13-11.3T265,26.85q6.74,0,10.49,4t3.76,11q0,6.87-4.06,11T264.32,56.91ZM264.63,32a7.43,7.43,0,0,0-6,2.67,11.11,11.11,0,0,0-2.22,7.34,10.49,10.49,0,0,0,2.25,7.11,7.52,7.52,0,0,0,6,2.6,7.15,7.15,0,0,0,5.9-2.56c1.38-1.7,2.06-4.12,2.06-7.26s-.68-5.6-2.06-7.32A7.11,7.11,0,0,0,264.63,32Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M298.3,19a6,6,0,0,0-3-.76q-4.74,0-4.74,5.36v3.9h6.67v5.1h-6.64V56.24h-6.51V32.63h-4.91v-5.1h4.91V22.87a9.06,9.06,0,0,1,3-7.16,10.81,10.81,0,0,1,7.43-2.62,11,11,0,0,1,3.82.53Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315.2,55.93a11.25,11.25,0,0,1-5,1q-8.37,0-8.36-8V32.63H297v-5.1h4.8V20.88l6.5-1.85v8.5h6.88v5.1h-6.88V47a5.62,5.62,0,0,0,.93,3.64,3.83,3.83,0,0,0,3.08,1.1,4.48,4.48,0,0,0,2.87-1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M364.61,56.24h-7.32L353.67,46H337.86l-3.48,10.23h-7.29L342.15,16h7.51Zm-12.7-15.67-5.58-16a19.31,19.31,0,0,1-.54-2.53h-.11a16.19,16.19,0,0,1-.56,2.53l-5.52,16Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M391.27,30.25,375.76,51.17h15.45v5.07H366.65V53.8l15.84-21.2H368.16V27.53h23.11Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420.67,56.24h-6.5V51.7h-.11a9.36,9.36,0,0,1-8.81,5.21q-10.19,0-10.18-12.22V27.53h6.51V44q0,7.74,6,7.74a6,6,0,0,0,4.75-2.14A8.13,8.13,0,0,0,414.17,44V27.53h6.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M442.93,33.72a5.46,5.46,0,0,0-3.4-.92,5.81,5.81,0,0,0-4.82,2.61,11.65,11.65,0,0,0-1.93,7.09V56.24h-6.51V27.53h6.51v5.91h.11a9.92,9.92,0,0,1,2.93-4.72,6.63,6.63,0,0,1,4.42-1.7,5.57,5.57,0,0,1,2.69.53Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M470.23,43.65H450.66a8.25,8.25,0,0,0,2.45,6.14A9.14,9.14,0,0,0,459.55,52,14.17,14.17,0,0,0,468,49.2v5.25q-3.93,2.46-10.38,2.46T447.67,53q-3.6-3.9-3.6-11a15.34,15.34,0,0,1,4-10.93,13,13,0,0,1,9.86-4.22q5.89,0,9.12,3.79t3.22,10.52ZM464,39.05a8.36,8.36,0,0,0-1.66-5.45,5.52,5.52,0,0,0-4.48-2,6.31,6.31,0,0,0-4.76,2.05,9.27,9.27,0,0,0-2.39,5.35Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureFull);
export default __webpack_public_path__ + "static/media/azure-full.c2dff7992ade381abf1b4d206b783a01.svg";
export { ForwardRef as ReactComponent };